import { IconWhatsapp } from './Icons';

const Contact = () => {
  // WhatsApp number: 0103956386 (Malaysia)
  // Format for WhatsApp: 60103956386 (remove leading 0, add country code 60)
  const WHATSAPP_NUMBER = '60103956386';

  const handleWhatsAppClick = () => {
    // Simple greeting message
    const message = encodeURIComponent("Hello! I'm interested in your services.");
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="contact" className="w-full bg-gradient-to-b from-gray-50 to-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/30">
            <span className="text-purple-600 text-sm font-semibold">Get Started</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ready to Transform Your <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">Business?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Get a free consultation and quote. Chat with us directly on WhatsApp. Our team responds within 24 hours with a customized solution for your business.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Trust Indicators */}
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Why Choose RPS Digital?</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 text-sm">100+ Successful Projects</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 text-sm">24/7 Support Available</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 text-sm">Money-Back Guarantee</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 text-sm">Free Consultation</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 text-sm">Transparent Pricing</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl p-6 text-white">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-lg">Fast Response</p>
                  <p className="text-sm opacity-90">We reply within 24 hours</p>
                </div>
              </div>
              <p className="text-sm opacity-90">
                Get a detailed quote and project timeline within 24 hours of submitting your inquiry.
              </p>
            </div>

            
          </div>

          {/* WhatsApp Button */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl p-12 shadow-xl border border-gray-200 text-center">
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Get in Touch</h3>
                <p className="text-gray-600 mb-6">Click the button below to chat with us directly on WhatsApp</p>
                
                {/* WhatsApp Info */}
                <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 flex items-center justify-center gap-3 mb-8 max-w-md mx-auto">
                  <IconWhatsapp className="w-6 h-6 text-green-600 flex-shrink-0" />
                  <div className="text-left">
                    <p className="font-semibold text-green-800">Chat with us on WhatsApp</p>
                    <p className="text-sm text-green-700">We'll respond as soon as possible!</p>
                  </div>
                </div>

                <button 
                  onClick={handleWhatsAppClick}
                  className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full text-white font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                  style={{ backgroundColor: '#25D366' }}
                >
                  <IconWhatsapp className="w-7 h-7" />
                  <span>Chat on WhatsApp</span>
                </button>

                <p className="text-center text-sm text-gray-500 mt-6">
                  💬 Click the button above to open WhatsApp and start chatting with us
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

